module.exports = __webpack_public_path__ + "media/1.71c230c7.mp3";